// import React from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, Navigation, Pagination } from "swiper/modules";

// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";

// const Testimonials = () => {
//  const testimonials = [
//   {
//     name: "Mr. Dipak Jadhаo",
//     position: "Business Traveler",
//     image: "/images/testimonial/pic1.png",
//     review:
//       "Everything was perfectly managed from pickup to drop. I booked Garudcabs for a family trip and everything was perfectly managed from pickup to drop. Without a doubt, they offer an outstation cab service in Pune that you can trust for long journeys. Their team also provides excellent customer support.",
//   },
//   {
//     name: "Mr. Vivek Thakur",
//     position: "Happy Passenger",
//     image: "/images/testimonial/pic2.png",
//     review:
//       "We had a wonderful experience with Garud Cab Pune for our 4 days trip to Jejuri - Kolhapur - Ratnagiri. The entire journey was smooth and well-organized.  Thanks to Shubham and our driver Sagar, who was extremely polite and ensured a safe and comfortable drive throughout the trip. His responsible driving made the journey relaxing.",
//   },
//   // {
//   //   name: "Mr. Ganesh Salunkhe",
//   //   position: "Regular Customer",
//   //   image: "/images/testimonial/pic3.png",
//   //   review:
//   //     "We had a wonderful experience with Garud Cab Pune for our one-day family trip to Mahabaleshwar from the Wagholi area. The cab was clean and comfortable, and the entire journey was smooth and well-organized. Our driver, Siddhik, was extremely polite, cooperative, and professional. He ensured a safe and comfortable drive throughout the trip and was very patient with our family during sightseeing. His responsible driving made the journey relaxing for everyone.We had a wonderful experience with Garud Cab Pune for our one-day family trip to Mahabaleshwar from the Wagholi area. The cab was clean and comfortable, and the entire journey was smooth and well-organized. Our driver, Siddhik, was extremely polite, cooperative, and professional. He ensured a safe and comfortable drive throughout the trip and was very patient with our family during sightseeing. His responsible driving made the journey relaxing for everyone.",
//   // },
//   {
//     name: "Mr. Vivek Wankhade",
//     position: "Outstation Traveler",
//     image: "/images/testimonial/pic1.png",
//     review:
//       "I booked a cab for an early morning airport drop in Pune. The driver reached before time and waited patiently. The car was clean and the ride was comfortable. I liked the overall service and will book again. For anyone searching for the best cab service in Pune, this is a good option.",
//   },
//   {
//     name: "Mr. Zubair Khan",
//     position: "Frequent Traveler",
//     image: "/images/testimonial/pic2.png",
//     review:
//       "Garudcabs made our weekend trip enjoyable with clean cars and courteous drivers. This is easily the best cab service in Pune for family and group travel. Their outstation cab service in Pune is affordable and very well-managed.",
//   },
//   {
//     name: "Mr. Pushpa Tukaram Mulik",
//     position: "Satisfied Customer",
//     image: "/images/testimonial/pic3.png",
//     review:
//       "I used Garud cabs for my family trip and found them very reliable. The driver reached on time, and the ride was smooth. This is surely the Best cab service in pune airport. Whenever I need cab service in pune, they will be my first choice. 🙏🙏🚘🚘",
//   },
// ];


//   return (
//     <div
//       className="section-full py-3 site-bg-white twm-testimonial-section-wrap wow fadeInDown"
//       data-wow-offset="100"
//       data-wow-delay="0.2"
//     >
//       <div className="container">

//         {/* ================= HEADER ================= */}
//         <div className="row align-items-end">
//           <div className="col-lg-8 col-md-8 col-8">
//             <div className="section-head left">
//               <div className="twm-sm-title left">
//                 Testimonials
//               </div>

//               <h2 className="twm-large-title site-text-dark">
//                 What Our Customers Say
//               </h2>
//             </div>
//           </div>

//           {/* TOP ARROWS */}
//           <div className="col-lg-4 col-md-4 col-4">
//             <div className="testimonial-navigation">

//               <button
//                 className="testimonial-prev"
//                 aria-label="Previous testimonial"
//               >
//                 <i className="fa fa-arrow-left"></i>
//               </button>

//               <button
//                 className="testimonial-next"
//                 aria-label="Next testimonial"
//               >
//                 <i className="fa fa-arrow-right"></i>
//               </button>

//             </div>
//           </div>
//         </div>

//         {/* ================= SLIDER ================= */}
//         <div className="section-content">
//           <Swiper
//             modules={[Autoplay, Navigation, Pagination]}
//             className="testimonial-slider"

//             /* Connect custom arrows */
//             navigation={{
//               prevEl: ".testimonial-prev",
//               nextEl: ".testimonial-next",
//             }}

//             /* Automatic sliding */
//             autoplay={{
//               delay: 3500,
//               disableOnInteraction: false,
//               pauseOnMouseEnter: true,
//             }}

//             /* Infinite loop */
//             loop={true}

//             /* Pagination */
//             pagination={{
//               clickable: true,
//             }}

//             spaceBetween={30}

//             /* Responsive */
//             breakpoints={{
//               0: {
//                 slidesPerView: 1,
//               },
//               576: {
//                 slidesPerView: 1,
//               },
//               768: {
//                 slidesPerView: 2,
//               },
//               1200: {
//                 slidesPerView: 3,
//               },
//             }}
//           >
//             {testimonials.map((testimonial, index) => (
//               <SwiperSlide key={index}>
//                 <div className="twm-testimonial2">

//                   {/* CUSTOMER */}
//                   <div className="twm-testimonial-head">

                   

//                     <div className="twm-author-detail">
//                       <h3 className="twm-title">
//                         {testimonial.name}
//                       </h3>

//                       <div className="twm-position">
//                         {testimonial.position}
//                       </div>
//                     </div>

//                   </div>

//                   {/* REVIEW */}
//                   <div className="twm-testimonial-detail">

//                     <p>{testimonial.review}</p>

//                     {/* STAR RATING */}
//                     <div className="twm-rating-wrap">
//                       {[1, 2, 3, 4, 5].map((star) => (
//                         <span key={star}>
//                           <i className="fa fa-star"></i>
//                         </span>
//                       ))}
//                     </div>

//                   </div>

//                   {/* QUOTE */}
//                   <div className="twm-quote-icon">
//                     <img
//                       src="/images/quote.png"
//                       alt="Quote"
//                     />
//                   </div>

//                 </div>
//               </SwiperSlide>
//             ))}
//           </Swiper>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default Testimonials;





import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const Testimonials = () => {

  // =====================================================
  // GOOGLE RATING DATA
  // =====================================================
  const [googleData, setGoogleData] = useState({
    rating: 4.9,
    totalReviews: 902,
  });

  // Google Review Link
  const googleReviewLink =
    "https://g.page/r/CSMg3R6S_DCOEBM/review";

  // =====================================================
  // GET LIVE GOOGLE RATING + TOTAL REVIEWS
  // =====================================================
  useEffect(() => {
    const getGoogleRating = async () => {
      try {
        const response = await fetch("/api/google-rating");

        if (!response.ok) {
          throw new Error("Unable to load Google rating");
        }

        const data = await response.json();

        setGoogleData({
          rating: data.rating || 4.9,
          totalReviews: data.totalReviews || 902,
        });
      } catch (error) {
        console.log("Google Rating Error:", error);

        // Fallback remains 4.9 / 902
      }
    };

    getGoogleRating();
  }, []);


  // =====================================================
  // TESTIMONIALS
  // =====================================================
  const testimonials = [
    {
      name: "Mr. Dipak Jadhao",
      position: "Business Traveler",
      review:
        "Everything was perfectly managed from pickup to drop. I booked Garudcabs for a family trip and everything was perfectly managed from pickup to drop. Without a doubt, they offer an outstation cab service in Pune that you can trust for long journeys. Their team also provides excellent customer support.",
    },
    {
      name: "Mr. Vivek Thakur",
      position: "Happy Passenger",
      review:
        "We had a wonderful experience with Garud Cab Pune for our 4 days trip to Jejuri - Kolhapur - Ratnagiri. The entire journey was smooth and well-organized. Thanks to Shubham and our driver Sagar, who was extremely polite and ensured a safe and comfortable drive throughout the trip.",
    },
    {
      name: "Mr. Vivek Wankhade",
      position: "Outstation Traveler",
      review:
        "I booked a cab for an early morning airport drop in Pune. The driver reached before time and waited patiently. The car was clean and the ride was comfortable. I liked the overall service and will book again. For anyone searching for the best cab service in Pune, this is a good option.",
    },
    {
      name: "Mr. Zubair Khan",
      position: "Frequent Traveler",
      review:
        "Garudcabs made our weekend trip enjoyable with clean cars and courteous drivers. This is easily the best cab service in Pune for family and group travel. Their outstation cab service in Pune is affordable and very well-managed.",
    },
    {
  name: "Mr. Siddharth Pandey",
  position: "Happy Customer",
  review:
    "Got in touch with these guys very last moment of my plan and I must say that I loved the overall engagement. Very clean cabs, polite drivers and fair pricing/costs breakup. I would urge everyone to try them out.",
},

{
  name: "Ms. Meenu Yadav",
  position: "Happy Customer",
  review:
    "I explored and found out about the Garudcabs Services. And I booked with them. Everything was effortless. The cab was clean every time. I booked it for 4 days straight, got the best price too. The driver was amazing and super helpful.",
},
    {
      name: "Mr. Pushpa Tukaram Mulik",
      position: "Satisfied Customer",
      review:
        "I used Garud cabs for my family trip and found them very reliable. The driver reached on time, and the ride was smooth. Whenever I need cab service in Pune, they will be my first choice. 🙏🙏🚘🚘",
    },

{
  name: "Ms. Mahima Mali",
  position: "Happy Customer",
  review:
    "Had a really comfortable and enjoyable trip. The driver was punctual, polite, and very helpful throughout the journey. He guided us well and made sure we could visit all the places comfortably without any hassle. The pricing was also fair and reasonable. Overall it was a very pleasant experience. Would definitely recommend it!",
},
{
  name: "Ms. Seema Kamat",
  position: "Happy Customer",
  review:
    "We went early morning four am from Borivali Mumbai to Mulshi Ghat Pune. Driver was prompt in arrival. Driving very smoothly throughout the ghats. Very polite. Had good experience travelling with Garuda Cabs. Highly professional and felt very safe and comfortable to travel. Thanks.",
},
{
  name: "Mr. Anay HIRVE",
  position: "Happy Customer",
  review:
    "The cab arrived on time, the driver was polite and professional, and the vehicle was clean. Highly recommended for local and outstation travel.",
},
{
  name: "Ms. Swayamprajnya",
  position: "Happy Customer",
  review:
    "We went for Malshej Ghat 1 day trip with cab professional Vicky. Ride was smooth, we didn't face any issues regarding the trip. All went well.",
},

  {
  name: "Mr. Siddhartha Gupta",
  position: "Happy Customer",
  review:
    "Excellent service and driver. On time every single day of our trip and no hassles. Smooth experience at an affordable price. Would love to use their service again.",
},
{
  name: "Mr. Ganpati Kamble",
  position: "Happy Customer",
  review:
    "Excellent service with affordable pricing. The booking process was easy, and the driver ensured a safe and comfortable journey throughout.",
},
{
  name: "Ms. Patil Pratibha",
  position: "Happy Customer",
  review:
    "Very reliable service and fair pricing. I felt comfortable throughout the journey. Truly the best cab service in Pune.",
},
{
  name: "Mr. Anil Dabhade",
  position: "Happy Customer",
  review:
    "Very easy booking process and quick response. The trip was comfortable and affordable. I would say it’s the best cab service in Pune.",
},

{
  name: "Mr. Roshan Nikde",
  position: "Happy Customer",
  review:
    "Went for an outstation trip with my family and had a great experience. The driver was friendly. It’s the best outstation cab service in Pune.",
},
{
  name: "Mr. Lokesh Lulla",
  position: "Happy Customer",
  review:
    "We have used Garud cabs services multiple times for friends and family travel and each time they provided good cabs and driver.",
},
{
  name: "Mr. Vivek Thakur",
  position: "Happy Customer",
  review:
    "We had a wonderful experience with Garud Cab Pune for our 4 days trip to Jejuri - Kolhapur - Ratnagiri, the entire journey was smooth and well-organized. Thanks Shubham and as well as Driver - Sagar, was extremely polite, He ensured a safe and comfortable drive throughout the trip & responsible driving made the journey relaxing... Thanks Again....",
},
{
  name: "Ms. Sayali Dhumal",
  position: "Happy Customer",
  review:
    "The cab was good bohot achi service provide kiya drive was good and polite, must try garudcabs best cab service in pune.",
},
{
  name: "Mr. Avi Patil",
  position: "Happy Customer",
  review:
    "I used Garudcabs for a family trip and the vehicle condition was excellent. One of the most trusted car rental services in Pune I've come across recently.",
},
{
  name: "Mr. Amol Dhakane",
  position: "Happy Customer",
  review:
    "I used services of Garudcabs and found them very professional, safe and punctual. I highly recommend Garudcabs if you are looking for a trusted Cab services partner.",
},
{
  name: "Mr. Md Hamid",
  position: "Happy Customer",
  review:
    "Booked a ride late night and was a bit worried, but Garudcabs didn’t disappoint. Their Taxi Service in Pune is reliable and available even during odd hours.",
},
{
  name: "Mr. Irfan Shaikh",
  position: "Happy Customer",
  review:
    "I recently booked Garudcabs for an airport drop, and honestly it was one of the smoothest rides I’ve had. The driver was polite and on time. If anyone is looking for the Best Cab Services in Pune, this is a solid option.",
},
{
  name: "Mr. Rampal Pal",
  position: "Happy Customer",
  review:
    "Very professional experience with Garudcabs. I needed a quick cab service in Pune for my office commute and they handled everything perfectly. Clean car and safe driving.",
},
{
  name: "Mr. Abhay Dubey",
  position: "Happy Customer",
  review:
    "Had a great outstation ride experience with Garudcabs. The driver was experienced and knew all routes well. Their Outstation Cab Services in Pune are definitely worth trying.",
},

{
  name: "Mr. Nitin Tayde",
  position: "Happy Customer",
  review:
    "Great experience overall. Booking process was simple and driver was very friendly. Definitely recommend this Cab Service in Pune for daily or occasional travel.",
},
{
  name: "Mr. Balasaheb Kolhe",
  position: "Happy Customer",
  review:
    "Best cab service. I needed a cab for a one-day meeting in the city and booked from this service. The driver was punctual and the car was clean inside and outside. The ride was comfortable throughout the day. I can say this is a dependable car rental service in Pune.",
},
{
  name: "Mr. Vivek Wankhade",
  position: "Happy Customer",
  review:
    "I booked a cab for an early morning airport drop in Pune. The driver reached before time and waited patiently. The car was clean and the ride was comfortable. I liked the overall service and will book again. For anyone searching for the best cab service in Pune, this is a good option.",
},
{
  name: "Mr. Vijay Patil",
  position: "Happy Customer",
  review:
    "We needed a cab for a family trip outside the city. The driver arrived on time and helped us with our bags. The journey was smooth and there were no issues during the trip. Overall it was a good experience using their outstation cab service in Pune.",
},
{
  name: "Mr. Sushil Ambhore",
  position: "Happy Customer",
  review:
    "Used this service for a pickup from the railway station. The driver called me when he arrived and helped with luggage. The ride was smooth and there were no delays. I would recommend this taxi service in Pune for anyone who wants a simple and reliable ride.",
},
{
  name: "Mr. Ashok Kute",
  position: "Happy Customer",
  review:
    "I booked a car for local travel in the city for a full day. The vehicle was neat and comfortable, and the driver knew the routes well. The pricing was also reasonable compared to other services. It is a good car rental service in Pune for daily travel needs.",
},
{
  name: "Ms. Manju Rai",
  position: "Happy Customer",
  review:
    "The cab came dot on time to pick us from the airport. Driver Patil was courteous and through Google Maps drove us to various locations within Pune comfortably. The pricing was transparent and reasonable. Would use their services again on my next visit to Pune.",
},
{
  name: "Mr. Deepak Bhusanar",
  position: "Happy Customer",
  review:
    "I needed a cab for a one-day meeting in the city and booked from this service. The driver was punctual and the car was clean inside and outside. The ride was comfortable throughout the day. I can say this is a dependable car rental service.",
},
{
  name: "Mr. Ankush Patil",
  position: "Happy Customer",
  review:
    "Had a good experience with this company. Booking the cab was simple and they confirmed the ride quickly. The driver was polite and drove safely throughout the trip. The car was well maintained. If you need a reliable taxi service in Pune, you can try them. Excellent service, thanks Garudcabs service team!",
},
{
  name: "Mr. Jitendra Kumar",
  position: "Happy Customer",
  review:
    "I regularly use Garudcabs for office travel and late-night rides. They are always dependable, drivers are courteous, and vehicles are well-maintained. I can confidently say they offer the most trustworthy Taxi Service in Pune.",
},
{
  name: "Mr. Nikhil Sasane",
  position: "Happy Customer",
  review:
    "We booked Garudcabs for an outstation trip and the experience was excellent from start to end. The vehicle was comfortable, well-maintained, and the driver knew the routes well. Our journey was peaceful and enjoyable. Truly one of the best Outstation Cab Services in Pune.",
},
{
  name: "Mr. Rajratna Patode",
  position: "Happy Customer",
  review:
    "I had a really great experience with Garudcabs. The driver arrived on time, the car was clean, and the ride was very smooth. The booking process was simple and the support team was helpful throughout. Without a doubt, they provide the Best Cab Service in Pune and I will definitely use them again.",
},
{
  name: "Mr. Vishal Padol",
  position: "Happy Customer",
  review:
    "My Jyotirling Darshan ride with Garudcabs was smooth, comfortable, and on time. They definitely provide top-quality taxi service in Pune with professional drivers. I would highly recommend them as the outstation cab service in Pune for stress-free travel.",
},
{
  name: "Mr. Zubair Khan",
  position: "Happy Customer",
  review:
    "Garudcabs made our weekend trip enjoyable with clean cars and courteous drivers. This is easily the best cab service in Pune for family and group travel. Their outstation cab service in Pune is affordable and very well-managed.",
},
{
  name: "Mr. Anand A",
  position: "Happy Customer",
  review:
    "You guys exceeded our expectations. Driver Shailesh is too kind and respectful, appreciate your team and management effort here. Outstanding service with reasonable price!",
},
{
  name: "Ms. Shruti Jadhav",
  position: "Happy Customer",
  review:
    "Garudcabs impressed me with their punctual drivers and hassle-free booking process. If you’re looking for a dependable taxi service in Pune, this is the right choice. They truly stand out as the best cab service in Pune for daily and corporate travel.",
},
{
  name: "Mr. Dipak Jadhao",
  position: "Happy Customer",
  review:
    "I booked Garudcabs for a family trip and everything was perfectly managed from pickup to drop. Without doubt, they offer the outstation cab service in Pune that you can trust for long journeys. Their team also provides the best cab service in Pune with excellent customer support.",
},
{
  name: "Ms. Ananya Reddy",
  position: "Happy Customer",
  review:
    "I traveled to Lonavala and Mumbai with my friends using Garud Cab Services. We chose an Ertiga for our journey, and the vehicle was very clean and well-maintained. Our driver, Mr. Ashish Hiralkar, was polite, punctual, and highly professional throughout the trip. Shubham coordinated the travel arrangements efficiently and provided excellent service at a reasonable price. Overall, our experience with Garud Cabs was excellent, and we are very satisfied with their service. Thank you.",
},
{
  name: "Mr. Viswanath Laxminarayan",
  position: "Happy Customer",
  review:
    "Dadasaheb Mane was our driver, very professional driver, was always on time. Even by 6am he was ready without any fuss. Vehicle was in good condition and comfortable.",
},
{
  name: "Mr. Shaikh Siddik",
  position: "Happy Customer",
  review:
    "My parents travelled with Garudcabs and they felt very comfortable. I can say they give the best taxi services in Pune. Recently I also tried their car rental services in Pune and the car was in very good condition.",
},
{
  name: "Ms. Sana Begum",
  position: "Happy Customer",
  review:
    "I had an urgent meeting and needed a quick ride, and Garudcabs arranged it without any trouble. They offer the best cab services in Pune. For weekends, their car rental services in Pune are very convenient and budget-friendly.",
},
{
  name: "Mr. Shaikh Siddik",
  position: "Happy Customer",
  review:
    "What impressed me is how well the drivers know the routes and traffic. That’s why I feel they provide the best taxi services in Pune. Their outstation cab service in Pune was also very reliable when I travelled to Mahabaleshwar.",
},
{
  name: "Mr. Balu Sawant",
  position: "Happy Customer",
  review:
    "I booked Garudcabs for my office commute for a week. In my experience, they offer the best taxi services in Pune. I also used their outstation cab service in Pune for a short trip and everything went perfectly.",
},
{
  name: "Mr. Siddu Danke",
  position: "Happy Customer",
  review:
    "The drivers are polite and always keep the ride comfortable. That’s why I think they provide the best cab services in Pune. Their outstation cab service in Pune made our family trip tension-free.",
},

  ];


  return (
    <div
      className="section-full py-3 site-bg-white twm-testimonial-section-wrap wow fadeInDown"
      data-wow-offset="100"
      data-wow-delay="0.2"
    >
      <div className="container">

        {/* =====================================================
            HEADER
        ===================================================== */}
        <div className="row align-items-end">

          <div className="col-lg-8 col-md-8 col-8">

            <div className="section-head left">

              <div className="twm-sm-title left">
                Testimonials
              </div>

              <h2 className="twm-large-title site-text-dark">
                What Our Customers Say
              </h2>

            </div>

          </div>


          {/* ARROWS */}
          <div className="col-lg-4 col-md-4 col-4">

            <div className="testimonial-navigation">

              <button
                className="testimonial-prev"
                aria-label="Previous testimonial"
              >
                <i className="fa fa-arrow-left"></i>
              </button>

              <button
                className="testimonial-next"
                aria-label="Next testimonial"
              >
                <i className="fa fa-arrow-right"></i>
              </button>

            </div>

          </div>

        </div>


        {/* =====================================================
            GOOGLE RATING BOX
        ===================================================== */}
        <div className="google-rating-box">

          {/* GOOGLE */}
          {/* <div className="google-rating-brand">

            <div className="google-g">
              G
            </div>

            <div>
              <strong>Google Rating</strong>
            </div>

          </div> */}
<div className="google-rating-brand">
  <div className="google-g">
    <svg
      width="32"
      height="32"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#EA4335"
        d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.61 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.4 17.74 9.5 24 9.5z"
      />
      <path
        fill="#4285F4"
        d="M46.5 24.5c0-1.56-.14-3.06-.4-4.5H24v9h12.65c-.55 2.96-2.23 5.47-4.74 7.16l7.72 6c4.51-4.16 6.87-10.28 6.87-17.66z"
      />
      <path
        fill="#FBBC05"
        d="M10.54 28.59A14.5 14.5 0 0 1 9.5 24c0-1.59.37-3.13 1.04-4.59l-7.98-6.19A23.98 23.98 0 0 0 0 24c0 3.88.93 7.57 2.56 10.78l7.98-6.19z"
      />
      <path
        fill="#34A853"
        d="M24 48c6.48 0 11.91-2.14 15.88-5.84l-7.72-6C30.03 37.45 27.27 38.5 24 38.5c-6.26 0-11.57-3.9-13.46-9.41l-7.98 6.19C6.51 42.62 14.61 48 24 48z"
      />
    </svg>
  </div>

  <div>
    <strong>Google Rating</strong>
  </div>
</div>


          {/* RATING NUMBER */}
          <div className="google-rating-number">

            <strong>
              {googleData.rating}
            </strong>

            <span>
              /5.0
            </span>

          </div>


          {/* STARS + TOTAL REVIEWS */}
          <div className="google-rating-reviews">

            <div className="google-stars">

              {[1, 2, 3, 4, 5].map((star) => (
                <i
                  className="fa fa-star"
                  key={star}
                ></i>
              ))}

            </div>

            <div className="google-review-count">

              Based on{" "}

              <strong>
                {googleData.totalReviews}
              </strong>

              {" "}Google Reviews

            </div>

          </div>


          {/* WRITE REVIEW */}
          <div className="google-review-action">

            <a
              href={googleReviewLink}
              target="_blank"
              rel="noopener noreferrer"
              className="google-review-btn text-white"
            >
              <span className="google-btn-g ">
                G
              </span>

              Write a Review
            </a>

          </div>

        </div>


        {/* =====================================================
            TESTIMONIAL SLIDER
        ===================================================== */}
        <div className="section-content">

          <Swiper
            modules={[
              Autoplay,
              Navigation,
              Pagination,
            ]}

            className="testimonial-slider"

            navigation={{
              prevEl: ".testimonial-prev",
              nextEl: ".testimonial-next",
            }}

            autoplay={{
              delay: 3500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}

            loop={true}

            pagination={{
              clickable: true,
            }}

            spaceBetween={30}

            breakpoints={{
              0: {
                slidesPerView: 1,
              },

              576: {
                slidesPerView: 1,
              },

              768: {
                slidesPerView: 2,
              },

              1200: {
                slidesPerView: 3,
              },
            }}
          >

            {testimonials.map(
              (testimonial, index) => (

                <SwiperSlide key={index}>

                  <div className="twm-testimonial2">

                    {/* STARS TOP */}
                    <div className="twm-rating-wrap">

                      {[1, 2, 3, 4, 5].map(
                        (star) => (

                          <span key={star}>
                            <i className="fa fa-star"></i>
                          </span>

                        )
                      )}

                    </div>


                    {/* REVIEW */}
                    <div className="twm-testimonial-detail">

                      <p>
                        "{testimonial.review}"
                      </p>

                    </div>


                    {/* CUSTOMER */}
                    <div className="twm-testimonial-head">

                      <div className="twm-author-detail">

                        <h3 className="twm-title">
                          {testimonial.name}
                        </h3>

                        <div className="twm-position">
                          {testimonial.position}
                        </div>

                      </div>

                    </div>


                    {/* QUOTE */}
                    <div className="twm-quote-icon">

                      <img
                        src="/images/quote.png"
                        alt="Quote"
                      />

                    </div>

                  </div>

                </SwiperSlide>

              )
            )}

          </Swiper>

        </div>

      </div>
    </div>
  );
};

export default Testimonials;